(ns app.front.requirement.subs
  (:require [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.requirement.events :as req-events]
            [app.front.view.attachment.common :as attachment-common]
            [app.front.view.workspace.subs :as ws-subs]
            [re-frame.core-instrumented :as rf]))

(defn remove-filled-attachment-requirements [requirements attachments]
  (->> requirements
       (remove (fn [req]
                 (->> attachments
                      (mapcat #(entities/get-id % :attachment/types))
                      (some #{(entities/get-id req :requirement/attachment-type)}))))))

(rf/reg-sub ::open-attachment-requirements
  (fn [[_ app-entity-id] _]
    [(rf/subscribe [::entities/entities
                    {:entity/type      :entity.type/requirement
                     :entity/parent    app-entity-id
                     :requirement/kind :requirement.kind/attachment}])
     (rf/subscribe [::entities/entities
                    {:entity/parent app-entity-id
                     :entity/type   :entity.type/attachment}])])
  (fn [[requirements attachments] _]
    (remove-filled-attachment-requirements requirements attachments)))


(rf/reg-sub ::all-attachment-requirements
  (fn [[_ app-entity-id] _]
    [(rf/subscribe [::entities/entities
                    {:entity/type      :entity.type/requirement
                     :entity/parent    app-entity-id
                     :requirement/kind :requirement.kind/attachment}])
     (rf/subscribe [::entities/entities
                    {:entity/parent app-entity-id
                     :entity/type   :entity.type/attachment}])
     (rf/subscribe [:language])])
  (fn [[requirements attachments lang] _]
    (->> requirements
         (map (fn [requirement]
                (let [attachment-count (->> attachments
                                            (filter (fn [attachment]
                                                      (some (or (entities/get-id attachment :attachment/types) #{})
                                                            (-> requirement
                                                                (entities/get-id :requirement/attachment-type)
                                                                vector
                                                                set))))
                                            count)
                      border-color     (if (> attachment-count 0)
                                         "border-ui-green"
                                         "border-ui-red-100")]
                  (merge (select-keys requirement [:db/id :requirement/attachment-type
                                                   :requirement/review :entity/created])
                         {:requirement/attachment-count attachment-count
                          :requirement/border-color     border-color
                          :requirement/title            (-> requirement
                                                            :requirement/attachment-type
                                                            (attachment-common/attachment-type-label lang))}))))
         (sort-by :requirement/title))))


(rf/reg-sub ::add-loading?
  (fn [db _]
    (get-in db [::req-events/requirements :add-loading?] false)))


(rf/reg-sub ::remove-loading?
  (fn [db _]
    (get-in db [::req-events/requirements :remove-loading?] false)))


(rf/reg-sub ::attachment-types
  :<- [:app.front.view.application/attachment-types-with-i18n]
  :<- [::ws-subs/enabled-attachment-type-ids]
  (fn [[attachment-types enabled-type-ids] [_ existing-requirements]]
    ;; Filter out attachment types that are already required
    (let [existing-types (->> existing-requirements
                              (map :requirement/attachment-type)
                              (map :db/id)
                              set)]
      (->> attachment-types
           (filter (fn [[_ type-id]] (contains? enabled-type-ids type-id)))
           (filter (fn [[_ type-id]] (not (some existing-types (-> type-id vector set)))))
           (map (fn [[text id]]
                  {:value id :text text}))))))

(rf/reg-sub ::can-add-requirements?
  (fn [[_ target-id]]
    [(rf/subscribe [::process/signal-permitted? target-id [:process.signal/add-attachment-requirement]])])
  (fn [[is-signal-permitted] _]
    is-signal-permitted))

;; Show attachment requirements list when:
;;
;; State machine signal to add new requirements is permitted AND currently viewing entity is application
;; OR (State machine signal is not permitted AND requirement list is not empty)
(rf/reg-sub ::show-requirements-list?
  (fn [[_ target-id] _]
    [(rf/subscribe [::all-attachment-requirements target-id])
     (rf/subscribe [::can-add-requirements? target-id])
     (rf/subscribe [::entities/context])])
  (fn [[requirements signal-permitted? ctx] [_ target-id]]
    (and (entities/find-entity ctx {:db/id target-id})
         (or (not-empty requirements)
             signal-permitted?))))

(rf/reg-sub ::review-session-confirmation
  (fn [db _]
    (get-in db [::req-events/requirements :session-confirmation])))
